import { getDiff, getDurationInDaysOrHours } from 'obt-common/date-utils';
import { FC } from 'react';
import { Icon } from '@spotnana/blocks/src/Icon';
import { useTranslation } from 'react-i18next';
import { Typography } from '@spotnana/blocks/src/Typography';
import { chip_container, status_icon } from './styles';

interface IProps {
  originalDate: string;
  date: string;
  dateFormat: string;
}

const DisruptionDifferenceLabel: FC<IProps> = ({ originalDate, date, dateFormat }) => {
  const { t: tt } = useTranslation('WEB');

  const dateDifference = getDiff(originalDate, date, 'hours', dateFormat, dateFormat);

  if (!dateDifference) {
    return null;
  }

  const isDelay = dateDifference > 0;
  const timeString = isDelay
    ? getDurationInDaysOrHours(originalDate, date)
    : getDurationInDaysOrHours(date, originalDate);

  return (
    <div css={chip_container}>
      <Icon name="TimeClock" css={status_icon} />

      <Typography variant="body3" kind="medium" color="warning">
        {isDelay ? tt('{{timeString}} delay', { timeString }) : tt('Early by {{timeString}}', { timeString })}
      </Typography>
    </div>
  );
};

export default DisruptionDifferenceLabel;
